// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// apiPath: Contiene la ruta de acceso al backend
export const environment: { apiPath: string; production: boolean; mode: "DEVELOPMENT" | "PRODUCTION" | "TESTING" | "REMOTE" } = {
  apiPath: "https://www.burodeconexiones.com/gcbalanced/",
  production: false,
  mode: "TESTING",
};

// ↓ Cambia la ruta de acuerdo a la badera
switch (environment.mode) {
  case "TESTING": environment.apiPath = "https://www.burodeconexiones.com/_gcbalanced/bcktest/"; break;
  case "PRODUCTION": environment.apiPath = "https://www.burodeconexiones.com/gcbalanced/"; break;
  case "DEVELOPMENT": environment.apiPath = "https://192.168.2.120/"; break;
  case "REMOTE": environment.apiPath = "https://192.168.1.9/"; break;
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
